export type CountryOption = {
  name: string;
  code: string;
  alternativeSpellings?: string;
  relevancyBooster?: number;
};

const countries: CountryOption[] = [
  {
    name: "Afghanistan",
    alternativeSpellings: "افغانستان",
    code: "AF",
  },
  {
    name: "Åland Islands",
    alternativeSpellings: "Aaland Aland",
    relevancyBooster: 0.5,
    code: "AX",
  },
  {
    name: "Albania",
    code: "AL",
  },
  {
    name: "Algeria",
    alternativeSpellings: "الجزائر",
    code: "DZ",
  },
  {
    name: "American Samoa",
    relevancyBooster: 0.5,
    code: "AS",
  },
  {
    name: "Andorra",
    relevancyBooster: 0.5,
    code: "AD",
  },
  {
    name: "Angola",
    code: "AO",
  },
  {
    name: "Anguilla",
    relevancyBooster: 0.5,
    code: "AI",
  },
  {
    name: "Antarctica",
    relevancyBooster: 0.5,
    code: "AQ",
  },
  {
    name: "Antigua And Barbuda",
    relevancyBooster: 0.5,
    code: "AG",
  },
  {
    name: "Argentina",
    code: "AR",
  },
  {
    name: "Armenia",
    alternativeSpellings: "Հայաստան",
    code: "AM",
  },
  {
    name: "Aruba",
    relevancyBooster: 0.5,
    code: "AW",
  },
  {
    name: "Australia",
    relevancyBooster: 1.5,
    code: "AU",
  },
  {
    name: "Austria",
    alternativeSpellings: "Österreich Osterreich Oesterreich ",
    code: "AT",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
  },
  {
    name: "Bahamas",
    code: "BS",
  },
  {
    name: "Bahrain",
    alternativeSpellings: "البحرين",
    code: "BH",
  },
  {
    name: "Bangladesh",
    alternativeSpellings: "বাংলাদেশ",
    relevancyBooster: 2,
    code: "BD",
  },
  {
    name: "Barbados",
    code: "BB",
  },
  {
    name: "Belarus",
    alternativeSpellings: "Беларусь",
    code: "BY",
  },
  {
    name: "Belgium",
    alternativeSpellings: "België Belgie Belgien Belgique",
    relevancyBooster: 1.5,
    code: "BE",
  },
  {
    name: "Belize",
    code: "BZ",
  },
  {
    name: "Benin",
    code: "BJ",
  },
  {
    name: "Bermuda",
    relevancyBooster: 0.5,
    code: "BM",
  },
  {
    name: "Bhutan",
    alternativeSpellings: "भूटान",
    code: "BT",
  },
  {
    name: "Bolivia",
    code: "BO",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    code: "BQ",
  },
  {
    name: "Bosnia and Herzegovina",
    alternativeSpellings: "BiH Bosna i Hercegovina Босна и Херцеговина",
    code: "BA",
  },
  {
    name: "Botswana",
    code: "BW",
  },
  {
    name: "Bouvet Island",
    code: "BV",
  },
  {
    name: "Brazil",
    alternativeSpellings: "Brasil",
    relevancyBooster: 2,
    code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
  },
  {
    name: "Bulgaria",
    alternativeSpellings: "България",
    code: "BG",
  },
  {
    name: "Burkina Faso",
    code: "BF",
  },
  {
    name: "Burundi",
    code: "BI",
  },
  {
    name: "Cambodia",
    alternativeSpellings: "កម្ពុជា",
    code: "KH",
  },
  {
    name: "Cameroon",
    code: "CM",
  },
  {
    name: "Canada",
    relevancyBooster: 2,
    code: "CA",
  },
  {
    name: "Cape Verde",
    alternativeSpellings: "Cabo",
    code: "CV",
  },
  {
    name: "Cayman Islands",
    relevancyBooster: 0.5,
    code: "KY",
  },
  {
    name: "Central African Republic",
    code: "CF",
  },
  {
    name: "Chad",
    alternativeSpellings: "تشاد‎ Tchad",
    code: "TD",
  },
  {
    name: "Chile",
    code: "CL",
  },
  {
    name: "China",
    alternativeSpellings: "Zhongguo Zhonghua Peoples Republic 中国/中华",
    relevancyBooster: 3.5,
    code: "CN",
  },
  {
    name: "Christmas Island",
    relevancyBooster: 0.5,
    code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    relevancyBooster: 0.5,
    code: "CC",
  },
  {
    name: "Colombia",
    code: "CO",
  },
  {
    name: "Comoros",
    alternativeSpellings: "جزر القمر",
    code: "KM",
  },
  {
    name: "Congo",
    code: "CG",
  },
  {
    name: "Congo, the Democratic Republic of the",
    alternativeSpellings: "Congo-Brazzaville Repubilika ya Kongo",
    code: "CD",
  },
  {
    name: "Cook Islands",
    relevancyBooster: 0.5,
    code: "CK",
  },
  {
    name: "Costa Rica",
    code: "CR",
  },
  {
    name: "Côte d'Ivoire",
    alternativeSpellings: "Cote dIvoire",
    code: "CI",
  },
  {
    name: "Croatia",
    alternativeSpellings: "Hrvatska",
    code: "HR",
  },
  {
    name: "Cuba",
    code: "CU",
  },
  {
    name: "Curaçao",
    alternativeSpellings: "Curacao",
    code: "CW",
  },
  {
    name: "Cyprus",
    alternativeSpellings: "Κύπρος Kýpros Kıbrıs",
    code: "CY",
  },
  {
    name: "Czech Republic",
    alternativeSpellings: "Česká Ceska",
    code: "CZ",
  },
  {
    name: "Denmark",
    alternativeSpellings: "Danmark",
    relevancyBooster: 1.5,
    code: "DK",
  },
  {
    name: "Djibouti",
    alternativeSpellings: "جيبوتي‎ Jabuuti Gabuuti",
    code: "DJ",
  },
  {
    name: "Dominica",
    alternativeSpellings: "Dominique",
    relevancyBooster: 0.5,
    code: "DM",
  },
  {
    name: "Dominican Republic",
    code: "DO",
  },
  {
    name: "Ecuador",
    code: "EC",
  },
  {
    name: "Egypt",
    relevancyBooster: 1.5,
    code: "EG",
  },
  {
    name: "El Salvador",
    code: "SV",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
  },
  {
    name: "Eritrea",
    alternativeSpellings: "إرتريا ኤርትራ",
    code: "ER",
  },
  {
    name: "Estonia",
    alternativeSpellings: "Eesti",
    code: "EE",
  },
  {
    name: "Ethiopia",
    alternativeSpellings: "ኢትዮጵያ",
    code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    relevancyBooster: 0.5,
    code: "FK",
  },
  {
    name: "Faroe Islands",
    alternativeSpellings: "Føroyar Færøerne",
    relevancyBooster: 0.5,
    code: "FO",
  },
  {
    name: "Fiji",
    alternativeSpellings: "Viti फ़िजी",
    code: "FJ",
  },
  {
    name: "Finland",
    alternativeSpellings: "Suomi",
    code: "FI",
  },
  {
    name: "France",
    alternativeSpellings: "République française",
    relevancyBooster: 2.5,
    code: "FR",
  },
  {
    name: "French Guiana",
    code: "GF",
  },
  {
    name: "French Polynesia",
    alternativeSpellings: "Polynésie française",
    code: "PF",
  },
  {
    name: "French Southern Territories",
    code: "TF",
  },
  {
    name: "Gabon",
    alternativeSpellings: "République Gabonaise",
    code: "GA",
  },
  {
    name: "Gambia",
    code: "GM",
  },
  {
    name: "Georgia",
    alternativeSpellings: "საქართველო",
    code: "GE",
  },
  {
    name: "Germany",
    alternativeSpellings: "Bundesrepublik Deutschland",
    relevancyBooster: 3,
    code: "DE",
  },
  {
    name: "Ghana",
    code: "GH",
  },
  {
    name: "Gibraltar",
    relevancyBooster: 0.5,
    code: "GI",
  },
  {
    name: "Greece",
    alternativeSpellings: "Ελλάδα",
    relevancyBooster: 1.5,
    code: "GR",
  },
  {
    name: "Greenland",
    alternativeSpellings: "grønland",
    relevancyBooster: 0.5,
    code: "GL",
  },
  {
    name: "Grenada",
    code: "GD",
  },
  {
    name: "Guadeloupe",
    code: "GP",
  },
  {
    name: "Guam",
    code: "GU",
  },
  {
    name: "Guatemala",
    code: "GT",
  },
  {
    name: "Guernsey",
    relevancyBooster: 0.5,
    code: "GG",
  },
  {
    name: "Guinea",
    code: "GN",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
  },
  {
    name: "Guyana",
    code: "GY",
  },
  {
    name: "Haiti",
    code: "HT",
  },
  {
    name: "Heard Island and McDonald Islands",
    code: "HM",
  },
  {
    name: "Holy See (Vatican City State)",
    relevancyBooster: 0.5,
    code: "VA",
  },
  {
    name: "Honduras",
    code: "HN",
  },
  {
    name: "Hong Kong",
    alternativeSpellings: "香港",
    code: "HK",
  },
  {
    name: "Hungary",
    alternativeSpellings: "Magyarország",
    code: "HU",
  },
  {
    name: "Iceland",
    alternativeSpellings: "Island",
    code: "IS",
  },
  {
    name: "India",
    alternativeSpellings: "भारत गणराज्य Hindustan",
    relevancyBooster: 3,
    code: "IN",
  },
  {
    name: "Indonesia",
    relevancyBooster: 2,
    code: "ID",
  },
  {
    name: "Iran, Islamic Republic of",
    alternativeSpellings: "ایران",
    code: "IR",
  },
  {
    name: "Iraq",
    alternativeSpellings: "العراق‎",
    code: "IQ",
  },
  {
    name: "Ireland",
    alternativeSpellings: "Éire",
    relevancyBooster: 1.2,
    code: "IE",
  },
  {
    name: "Isle of Man",
    relevancyBooster: 0.5,
    code: "IM",
  },
  {
    name: "Israel",
    alternativeSpellings: "إسرائيل ישראל",
    code: "IL",
  },
  {
    name: "Italy",
    alternativeSpellings: "Italia",
    relevancyBooster: 2,
    code: "IT",
  },
  {
    name: "Jamaica",
    code: "JM",
  },
  {
    name: "Japan",
    alternativeSpellings: "Nippon Nihon 日本",
    relevancyBooster: 2.5,
    code: "JP",
  },
  {
    name: "Jersey",
    relevancyBooster: 0.5,
    code: "JE",
  },
  {
    name: "Jordan",
    alternativeSpellings: "الأردن",
    code: "JO",
  },
  {
    name: "Kazakhstan",
    alternativeSpellings: "Қазақстан Казахстан",
    code: "KZ",
  },
  {
    name: "Kenya",
    code: "KE",
  },
  {
    name: "Kiribati",
    code: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of",
    alternativeSpellings: "North Korea",
    code: "KP",
  },
  {
    name: "Korea, Republic of",
    alternativeSpellings: "South Korea",
    relevancyBooster: 1.5,
    code: "KR",
  },
  {
    name: "Kuwait",
    alternativeSpellings: "الكويت",
    code: "KW",
  },
  {
    name: "Kyrgyzstan",
    alternativeSpellings: "Кыргызстан",
    code: "KG",
  },
  {
    name: "Lao People's Democratic Republic",
    code: "LA",
  },
  {
    name: "Latvia",
    alternativeSpellings: "Latvija",
    code: "LV",
  },
  {
    name: "Lebanon",
    alternativeSpellings: "لبنان",
    code: "LB",
  },
  {
    name: "Lesotho",
    code: "LS",
  },
  {
    name: "Liberia",
    code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",
    alternativeSpellings: "ليبيا",
    code: "LY",
  },
  {
    name: "Liechtenstein",
    code: "LI",
  },
  {
    name: "Lithuania",
    alternativeSpellings: "Lietuva",
    code: "LT",
  },
  {
    name: "Luxembourg",
    code: "LU",
  },
  {
    name: "Macao",
    code: "MO",
  },
  {
    name: "Macedonia, The Former Yugoslav Republic Of",
    alternativeSpellings: "Македонија",
    code: "MK",
  },
  {
    name: "Madagascar",
    alternativeSpellings: "Madagasikara",
    code: "MG",
  },
  {
    name: "Malawi",
    code: "MW",
  },
  {
    name: "Malaysia",
    code: "MY",
  },
  {
    name: "Maldives",
    code: "MV",
  },
  {
    name: "Mali",
    code: "ML",
  },
  {
    name: "Malta",
    code: "MT",
  },
  {
    name: "Marshall Islands",
    relevancyBooster: 0.5,
    code: "MH",
  },
  {
    name: "Martinique",
    code: "MQ",
  },
  {
    name: "Mauritania",
    alternativeSpellings: "الموريتانية",
    code: "MR",
  },
  {
    name: "Mauritius",
    code: "MU",
  },
  {
    name: "Mayotte",
    code: "YT",
  },
  {
    name: "Mexico",
    alternativeSpellings: "Mexicanos",
    relevancyBooster: 1.5,
    code: "MX",
  },
  {
    name: "Micronesia, Federated States of",
    code: "FM",
  },
  {
    name: "Moldova, Republic of",
    code: "MD",
  },
  {
    name: "Monaco",
    code: "MC",
  },
  {
    name: "Mongolia",
    alternativeSpellings: "Mongγol ulus Монгол улс",
    code: "MN",
  },
  {
    name: "Montenegro",
    code: "ME",
  },
  {
    name: "Montserrat",
    relevancyBooster: 0.5,
    code: "MS",
  },
  {
    name: "Morocco",
    alternativeSpellings: "المغرب",
    code: "MA",
  },
  {
    name: "Mozambique",
    alternativeSpellings: "Moçambique",
    code: "MZ",
  },
  {
    name: "Myanmar",
    code: "MM",
  },
  {
    name: "Namibia",
    alternativeSpellings: "Namibië",
    code: "NA",
  },
  {
    name: "Nauru",
    alternativeSpellings: "Naoero",
    relevancyBooster: 0.5,
    code: "NR",
  },
  {
    name: "Nepal",
    alternativeSpellings: "नेपाल",
    code: "NP",
  },
  {
    name: "Netherlands",
    alternativeSpellings: "Holland Nederland",
    relevancyBooster: 1.5,
    code: "NL",
  },
  {
    name: "New Caledonia",
    relevancyBooster: 0.5,
    code: "NC",
  },
  {
    name: "New Zealand",
    alternativeSpellings: "Aotearoa",
    code: "NZ",
  },
  {
    name: "Nicaragua",
    code: "NI",
  },
  {
    name: "Niger",
    alternativeSpellings: "Nijar",
    code: "NE",
  },
  {
    name: "Nigeria",
    alternativeSpellings: "Nijeriya Naíjíríà",
    relevancyBooster: 1.5,
    code: "NG",
  },
  {
    name: "Niue",
    relevancyBooster: 0.5,
    code: "NU",
  },
  {
    name: "Norfolk Island",
    relevancyBooster: 0.5,
    code: "NF",
  },
  {
    name: "Northern Mariana Islands",
    relevancyBooster: 0.5,
    code: "MP",
  },
  {
    name: "Norway",
    alternativeSpellings: "Norge Noreg",
    relevancyBooster: 1.5,
    code: "NO",
  },
  {
    name: "Oman",
    alternativeSpellings: "عمان",
    code: "OM",
  },
  {
    name: "Pakistan",
    alternativeSpellings: "پاکستان",
    relevancyBooster: 2,
    code: "PK",
  },
  {
    name: "Palau",
    relevancyBooster: 0.5,
    code: "PW",
  },
  {
    name: "Palestinian Territory, Occupied",
    alternativeSpellings: "فلسطين",
    code: "PS",
  },
  {
    name: "Panama",
    code: "PA",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
  },
  {
    name: "Paraguay",
    code: "PY",
  },
  {
    name: "Peru",
    code: "PE",
  },
  {
    name: "Philippines",
    alternativeSpellings: "Pilipinas",
    relevancyBooster: 1.5,
    code: "PH",
  },
  {
    name: "Pitcairn",
    relevancyBooster: 0.5,
    code: "PN",
  },
  {
    name: "Poland",
    alternativeSpellings: "Polska",
    relevancyBooster: 1.25,
    code: "PL",
  },
  {
    name: "Portugal",
    alternativeSpellings: "Portuguesa",
    relevancyBooster: 1.5,
    code: "PT",
  },
  {
    name: "Puerto Rico",
    code: "PR",
  },
  {
    name: "Qatar",
    alternativeSpellings: "قطر",
    code: "QA",
  },
  {
    name: "Réunion",
    alternativeSpellings: "Reunion",
    code: "RE",
  },
  {
    name: "Romania",
    alternativeSpellings: "Rumania Roumania România",
    code: "RO",
  },
  {
    name: "Russian Federation",
    alternativeSpellings: "Rossiya Российская Россия",
    relevancyBooster: 2.5,
    code: "RU",
  },
  {
    name: "Rwanda",
    code: "RW",
  },
  {
    name: "Saint Barthélemy",
    alternativeSpellings: "St. Barthelemy",
    code: "BL",
  },
  {
    name: "Saint Helena",
    alternativeSpellings: "St.",
    code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    alternativeSpellings: "St.",
    code: "KN",
  },
  {
    name: "Saint Lucia",
    alternativeSpellings: "St.",
    code: "LC",
  },
  {
    name: "Saint Martin (French Part)",
    alternativeSpellings: "St.",
    code: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    alternativeSpellings: "St.",
    code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    alternativeSpellings: "St.",
    code: "VC",
  },
  {
    name: "Samoa",
    code: "WS",
  },
  {
    name: "San Marino",
    alternativeSpellings: "RSM Repubblica",
    code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
  },
  {
    name: "Saudi Arabia",
    alternativeSpellings: "السعودية",
    code: "SA",
  },
  {
    name: "Senegal",
    alternativeSpellings: "Sénégal",
    code: "SN",
  },
  {
    name: "Serbia",
    alternativeSpellings: "Србија Srbija",
    code: "RS",
  },
  {
    name: "Seychelles",
    relevancyBooster: 0.5,
    code: "SC",
  },
  {
    name: "Sierra Leone",
    code: "SL",
  },
  {
    name: "Singapore",
    alternativeSpellings: "Singapura  சிங்கப்பூர் குடியரசு 新加坡共和国",
    code: "SG",
  },
  {
    name: "Sint Maarten (Dutch Part)",
    code: "SX",
  },
  {
    name: "Slovakia",
    alternativeSpellings: "Slovenská Slovensko",
    code: "SK",
  },
  {
    name: "Slovenia",
    alternativeSpellings: "Slovenija",
    code: "SI",
  },
  {
    name: "Solomon Islands",
    code: "SB",
  },
  {
    name: "Somalia",
    alternativeSpellings: "الصومال",
    code: "SO",
  },
  {
    name: "South Africa",
    alternativeSpellings: "RSA Suid-Afrika",
    code: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
  },
  {
    name: "South Sudan",
    code: "SS",
  },
  {
    name: "Spain",
    alternativeSpellings: "España",
    relevancyBooster: 2,
    code: "ES",
  },
  {
    name: "Sri Lanka",
    alternativeSpellings: "ශ්‍රී ලංකා இலங்கை Ceylon",
    code: "LK",
  },
  {
    name: "Sudan",
    alternativeSpellings: "السودان",
    code: "SD",
  },
  {
    name: "Suriname",
    alternativeSpellings: "शर्नम् Sarnam Sranangron",
    code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    relevancyBooster: 0.5,
    code: "SJ",
  },
  {
    name: "Swaziland",
    alternativeSpellings: "weSwatini Swatini Ngwane",
    code: "SZ",
  },
  {
    name: "Sweden",
    alternativeSpellings: "Sverige",
    relevancyBooster: 1.5,
    code: "SE",
  },
  {
    name: "Switzerland",
    alternativeSpellings: "Swiss Confederation Schweiz Suisse Svizzera Svizra",
    relevancyBooster: 1.5,
    code: "CH",
  },
  {
    name: "Syrian Arab Republic",
    alternativeSpellings: "Syria سورية",
    code: "SY",
  },
  {
    name: "Taiwan",
    alternativeSpellings: "台灣 臺灣",
    code: "TW",
  },
  {
    name: "Tajikistan",
    alternativeSpellings: "Тоҷикистон Toçikiston",
    code: "TJ",
  },
  {
    name: "Tanzania, United Republic of",
    code: "TZ",
  },
  {
    name: "Thailand",
    alternativeSpellings: "ประเทศไทย Prathet Thai",
    code: "TH",
  },
  {
    name: "Timor-Leste",
    code: "TL",
  },
  {
    name: "Togo",
    alternativeSpellings: "Togolese",
    code: "TG",
  },
  {
    name: "Tokelau",
    relevancyBooster: 0.5,
    code: "TK",
  },
  {
    name: "Tonga",
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
  },
  {
    name: "Tunisia",
    alternativeSpellings: "تونس",
    code: "TN",
  },
  {
    name: "Turkey",
    alternativeSpellings: "Türkiye Turkiye",
    code: "TR",
  },
  {
    name: "Turkmenistan",
    alternativeSpellings: "Türkmenistan",
    code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    relevancyBooster: 0.5,
    code: "TC",
  },
  {
    name: "Tuvalu",
    relevancyBooster: 0.5,
    code: "TV",
  },
  {
    name: "Uganda",
    code: "UG",
  },
  {
    name: "Ukraine",
    alternativeSpellings: "Ukrayina Україна",
    code: "UA",
  },
  {
    name: "United Arab Emirates",
    alternativeSpellings: "UAE الإمارات",
    code: "AE",
  },
  {
    name: "United Kingdom",
    alternativeSpellings:
      "Great Britain England UK Wales Scotland Northern Ireland",
    relevancyBooster: 2.5,
    code: "GB",
  },
  {
    name: "United States",
    relevancyBooster: 3.5,
    alternativeSpellings: "USA United States of America",
    code: "US",
  },
  {
    name: "United States Minor Outlying Islands",
    code: "UM",
  },
  {
    name: "Uruguay",
    code: "UY",
  },
  {
    name: "Uzbekistan",
    alternativeSpellings: "Ўзбекистон O'zbekstan O‘zbekiston",
    code: "UZ",
  },
  {
    name: "Vanuatu",
    code: "VU",
  },
  {
    name: "Venezuela",
    code: "VE",
  },
  {
    name: "Vietnam",
    alternativeSpellings: "Việt Nam",
    relevancyBooster: 1.5,
    code: "VN",
  },
  {
    name: "Virgin Islands, British",
    relevancyBooster: 0.5,
    code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    relevancyBooster: 0.5,
    code: "VI",
  },
  {
    name: "Wallis and Futuna",
    relevancyBooster: 0.5,
    code: "WF",
  },
  {
    name: "Western Sahara",
    alternativeSpellings: "لصحراء الغربية",
    code: "EH",
  },
  {
    name: "Yemen",
    alternativeSpellings: "اليمن",
    code: "YE",
  },
  {
    name: "Zambia",
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
  },
];

export default countries;
